var _stop, _stop2, _feFlood, _feBlend, _feGaussianBlur;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgHeroEclipse = function SvgHeroEclipse(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1124,
    height: 1091,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id2, ")")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M920.111 253.229c132.489 162.499 79.349 425.137-118.703 586.62-198.052 161.481-466.012 160.661-598.506-1.839-132.494-162.498-79.349-425.137 118.702-586.619 198.052-161.483 466.012-160.66 598.507 1.838Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _id,
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(97.097 39.8 520.778) scale(457.384 841.838)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EA90"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#001FC8",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("filter", {
    id: _id2,
    width: 1122.99,
    height: 1089.61,
    x: 0.01,
    y: 0.815,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_11355_197862",
    stdDeviation: 65
  })))));
};
export default SvgHeroEclipse;